/** @format */

import React from 'react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { ONBOARDING_PAGE_ID } from 'src/constants';
import { getFooterLinksInfo } from 'src/slices/global';
import { getWidgetInfo } from 'src/slices/users';
import { useDispatch, useSelector } from 'src/store';
import i18n from '../../i18n';
import { setPersistedAcceptLanguage } from 'src/utils/acceptLanguage';
import { Footer } from '../footer';
import GlobalHeader from '../globalHeader';
import { Header } from '../header';

const DefaultLayout = props => {
  const { isAuthenticated, user } = useAuth();
  const { widgetInfo, userData } = useSelector(state => state.users);
  const [userLang, setLang] = useState();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const onboardingPath = `/page/${ONBOARDING_PAGE_ID}`;
  useEffect(() => {
    if (
      user &&
      (user.onBoardingComplete === false || user.onBoardingComplete === undefined) &&
      location.pathname !== onboardingPath
    ) {
      history.push(onboardingPath);
    }
  }, [user, location.pathname, history]);

  useEffect(() => {
    const lang = i18n.language || 'en';
    setLang(lang);
    if (user?.locale && !widgetInfo) {
      dispatch(getWidgetInfo());
    }
  }, [user, widgetInfo, i18n.language, dispatch]);

  const getSelectLang = e => {
    const { value } = e.target;
    setPersistedAcceptLanguage(value);
    i18n.changeLanguage(value);
    const url = new URL(window.location.href);
    url.searchParams.set('language', value);
    window.location.href = url.toString();
  };

  return (
    <section className="main_section">
      <Header getSelectLang={getSelectLang} userLang={userLang} />
      <div className="content">
        {
          isAuthenticated && props.children // check if logined show content
        }
      </div>
      <Footer />
    </section>
  );
};

export { DefaultLayout };
